<template>
  <div>
    <v-card tile flat>
      <v-card-text class="pa-0">
        <v-row class="bg-kiri" no-gutters>
          <v-col cols="12" md="2" sm="12" class="mt-5">
            <base-photo-profil
              class="mx-5"
              :photo="$getDeepObj(this, 'akun.foto') || ''"
              photodef="default_foto_gp.png"
              :useBase64="true"
              :isEdit="false"
              @upload="onUploadFoto"
              @reload="onReload"
            />
          </v-col>
          <v-col cols="12" md="10" sm="12" style="background-color: white">
            <v-toolbar dense flat>
              <v-toolbar-title>
                <h1 class="headline info--text font-weight-bold"> Data Profil Anda </h1>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-icon v-if="true" @click="onEdit">mdi-pencil</v-icon>
            </v-toolbar>
            <div class="pa-2 pt-0">
              <v-alert dense icon="mdi-information" type="warning" colored-border class="bg-notif ma-0">
                Anda dapat mengubah data <b>nomor telepon, dan akun bank</b> dengan menekan icon pensil di kanan
              </v-alert>
              <v-row dense class="pa-2">
                <v-col v-for="(item, index) in profils['dasar']" :key="index" v-bind="item.grid">
                  <div class="subtitle-2 grey--text font-weight-regular">{{ item.label }} </div>
                  <div class="black--text">
                    {{ item.value }}
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <base-modal-full ref="modal" title="Kelola Profil" @save="onSave">
      <form-profil-asesor
        ref="formulir"
        :initValue="formulir.init"
        :masters="masters"
        generalError
      ></form-profil-asesor>
    </base-modal-full>
    <popup-preview-detail ref="preview" :url="view.url || ''" title="Foto Cover Tabungan"></popup-preview-detail>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import FormProfilAsesor from './form/Profil';
import PopupPreviewDetail from '@components/popup/PreviewDetil';
import BasePhotoProfil from '@/components/base/BasePhotoProfil';

export default {
  name: 'ProfilAsessor',
  components: { BasePhotoProfil, FormProfilAsesor, PopupPreviewDetail },
  data() {
    return {
      formulir: {},
      view: {},
    };
  },
  computed: {
    ...mapState('preferensi', {
      akun: (state) => state?.data?.akun ?? {},
    }),

    ...mapState('master', {
      masters: (state) => state.masters || {},
    }),

    profils() {
      return {
        dasar: [
          {
            key: 'nama',
            label: 'Nama Lengkap',
            value: this.$getDeepObj(this.akun, 'nama') || '-',
            grid: { cols: 12, md: 6, sm: 12 },
          },
          {
            key: 'bank',
            label: 'Akun Bank',
            value: this.$getDeepObj(this.akun, 'rekening_bank') || '',
            grid: { cols: 12, md: 6, sm: 12 },
          },
          {
            key: 'email',
            label: 'Alamat Email',
            value: this.$getDeepObj(this.akun, 'email') || '-',
            grid: { cols: 12, md: 6, sm: 12 },
          },
          {
            key: 'nomor_rek',
            label: 'Nomor Rekening',
            value: this.$getDeepObj(this.akun, 'rekening_nomor') || '-',
            grid: { cols: 12, md: 6, sm: 12 },
          },
          {
            key: 'instansi',
            label: 'Asal Insansi',
            value: this.$getDeepObj(this.akun, 'instansi_asal') || '-',
            grid: { cols: 12, md: 6, sm: 12 },
          },
          {
            key: 'nama_pemilik',
            label: 'Nama Rekening',
            value: this.$getDeepObj(this.akun, 'rekening_nama') || '-',
            grid: { cols: 12, md: 6, sm: 12 },
          },
          {
            key: 'no_hp',
            label: 'Nomor Telepon',
            value: this.$getDeepObj(this.akun, 'no_hp') || '-',
            grid: { cols: 12, md: 6, sm: 12 },
          },
          {
            key: 'rekening_cabang',
            label: 'Nama Cabang',
            value: this.$getDeepObj(this.akun, 'rekening_cabang') || '-',
            grid: { cols: 12, md: 6, sm: 12 },
          },
        ],
      };
    },

    kodeBank() {
      const mBank = this.$mapForMaster(this.$getDeepObj(this, 'masters.bank') || {});
      const kode_bank = this.$getDeepObj(this, 'akun.rekening_bank') || '';
      return mBank.find((item) => String(item.text).includes(String(kode_bank).trim())) || {};
    },
  },
  created() {
    this.getMasters('bank');
  },
  methods: {
    ...mapActions('master', ['getMasters']),
    ...mapActions('preferensi', ['getPreferensi']),
    ...mapActions('profil', ['saveProfil', 'profil']),

    onEdit() {
      const form = {
        nama: this.$getDeepObj(this, 'akun.nama') || '-',
        ptk_id: this.$getDeepObj(this, 'akun.ptk_id') || '',
        no_hp: this.$getDeepObj(this, 'akun.no_hp') || '',
        email: this.$getDeepObj(this, 'akun.email') || '-',
        rekening_bank: this.$getDeepObj(this.kodeBank, 'value') || '',
        rekening_nomor: this.$getDeepObj(this, 'akun.rekening_nomor') || '',
        rekening_nama: this.$getDeepObj(this, 'akun.rekening_nama') || '',
        instansi_asal: this.$getDeepObj(this, 'akun.instansi_asal') || '-',
        rekening_cabang: this.$getDeepObj(this, 'akun.rekening_cabang') || '',
        foto_tabungan: '',
      };

      this.$set(this.formulir, 'init', null);
      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
        this.$set(this.formulir, 'init', form);
      });
    },

    onSave() {
      const form = this.$refs.formulir.form || {};
      const keys = ['instansi_asal', 'rekening_nomor', 'rekening_bank', 'rekening_nama', 'rekening_cabang', 'no_hp'];
      const required = [
        'no_hp',
        'instansi_asal',
        'rekening_nomor',
        'rekening_bank',
        'rekening_nama',
        'rekening_cabang',
      ];
      const params = {};
      const errors = [];
      const labels = {
        no_hp: 'Nomor HP',
        instansi_asal: 'Asal instansi',
        rekening_nomor: 'Nomor Rekening',
        rekening_bank: 'Nama Bank',
        rekening_cabang: 'Nama Cabang',
        rekening_nama: 'Nama Pemilik Rekening',
      };

      keys.forEach((s) => {
        if (!form[s] && required.includes(s)) {
          errors.push(labels[s] + ' Wajib diisi');
        }
      });

      if (errors.length) {
        this.$error(errors.join('<br/>'));
        this.$refs.modal.loading = false;
        return;
      }

      keys.forEach((s) => {
        if (s === 'rekening_bank') {
          this.$set(params, s, this.masters['bank'][form[s]]);
        } else {
          this.$set(params, s, form[s] || '');
        }
      });

      this.saveProfil({ params })
        .then(() => {
          this.onReload();
          this.$refs.modal.close();
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },

    onPreview() {
      this.$refs.preview.open();
    },

    onUploadFoto(data) {
      this.uploadFoto(data).then(() => {
        this.onReload();
      });
    },

    onReload() {
      this.getPreferensi(true);
    },
  },
};
</script>
<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
.sc-notif {
  background-color: #c8e6c9;
}
</style>
